import React, { Component } from "react";
import { reorderDashboardWidgets } from "api/dashboard.js";
import { calculateLinearIndex, getDefaultLayout, getLayouts, getGridWidth, validateOrder } from "./DashboardUtils.jsx";

import { sortWidgetsBasedOnOrder } from "utils/utils.js";
import GridLayoutDragDrop from "components/GridLayout/index.jsx";
import Card from "./Card.js";
import GRID_CONSTANTS from "components/GridLayout/GridConstants.jsx";
import { WIDGET_TYPE } from "constants/constantStrings";
import "./ProjStyles.scss";

class DashboardMain extends Component {
  constructor(props) {
    super(props);
    const widgetWithWidth = this.props.dashboardMainWidgets.map(item => ({
      ...item,
      width: getGridWidth(item.Type)
    }));
    this.state = {
      files: this.props.dashboardMainWidgets,
      layouts: getDefaultLayout(widgetWithWidth),
      isDashboardPanelOpened: this.props.isDashboardPanelOpened,
      isToReorder: this.props.isToReorder
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.dashboardMainWidgets !== state.files) {
      let updatedWidgets = props.dashboardMainWidgets.map(updatedWidget => ({
        ...updatedWidget,
        width: getGridWidth(updatedWidget.Type)
      }));

      const formattedWidgetsData = { files: updatedWidgets, isDashboardPanelOpened: props.isDashboardPanelOpened, isToReorder: false };
      if (!validateOrder(props.dashboardMainWidgets) && state.isToReorder) {
        const localLayouts = getLayouts(updatedWidgets);
        const orderOnLocal = localLayouts.map(widget => {
          return { order: calculateLinearIndex(widget.y, widget.x), id: parseInt(widget.i) };
        });
        const jsonData = {};
        for (const obj of orderOnLocal) {
          let columnName = obj.id;
          jsonData[columnName] = obj.order;
        }
        const payload = { Order: jsonData, LayoutID: props.currentLayoutID };
        DashboardMain.reorderWidgets(payload);
        updatedWidgets = updatedWidgets.map(item1 => {
          const clientWidgetOrder = orderOnLocal.find(item2 => item2.id === item1.Id);
          if (clientWidgetOrder) {
            return { ...item1, Order: clientWidgetOrder.order };
          }
          return item1;
        });
        props.setDashboardMainWidgets(updatedWidgets);

        formattedWidgetsData.layouts = orderOnLocal;
      } else {
        formattedWidgetsData.layouts = getDefaultLayout(updatedWidgets);
      }
      return formattedWidgetsData;
    }
    if (props.isDashboardPanelOpened !== state.isDashboardPanelOpened) {
      return { isDashboardPanelOpened: props.isDashboardPanelOpened };
    }
    return null;
  }

  static reorderWidgets = async payload => {
    try {
      const response = await reorderDashboardWidgets(payload);
    } catch (error) { }
  };

  getClassName = widgetType => (widgetType === WIDGET_TYPE.timeseries ? "timeseriesCardWidth" : "gaugeCardWidth");

  onDragEndNew = async layout => {
    this.setState({ layouts: layout });
    const jsonData = {};
    layout.forEach(item => {
      const { i, x, y } = item;
      const columnName = parseInt(i);
      jsonData[columnName] = calculateLinearIndex(y, x);
    });
    const payload = { Order: jsonData, LayoutID: this.props.currentLayoutID };
    const response = await reorderDashboardWidgets(payload);
    this.props.setDashboardMainWidgets(sortWidgetsBasedOnOrder(response));
  };

  render() {
    const { files } = this.state;
    const widgetID = (item) => `dashboard_${item.Type || ''}_${item?.Attributes?.SystemTag[0] || ''}`.toLowerCase();
    return (
      <GridLayoutDragDrop
        rowHeight={GRID_CONSTANTS.MAX_ROW_HEIGHT_DASHBOARD}
        layouts={this.state.layouts}
        onDragEnd={this.onDragEndNew}
        noOfItemPerCol={GRID_CONSTANTS.MAX_GRID_COLS_DASHBOARD}
        isDashboardPanelOpened={this.state.isDashboardPanelOpened}
      >
        {files.map((file, index) => (
          <div id={widgetID(file)} className={this.getClassName(file.Type)} key={file.Id.toString().toString()}>
            <Card item={file} onWidgetAction={this.props.onWidgetAction} isWidgetUpdating={file.isUpdating} />
          </div>
        ))}
      </GridLayoutDragDrop>
    );
  }
}

export default DashboardMain;
